import { Input } from '@lms/ui/input';
import { Label } from '@lms/ui/label';
import { type FormEvent, useState } from 'react';
import { useTranslations } from 'use-intl';
import { SubmitButton } from '@/components/submit-button';
import { addSurveySchema } from '@/features/survey/actions.schema';
import { addSurvey } from '@/features/survey/survey-admin-api';

// Ports features/survey/components/add-survey.tsx. The Next conform form driven
// by a server action becomes a controlled form calling `addSurvey`; the caller
// navigates to the surveys list via `onSuccess` in place of the action's
// `redirect`.
export default function AddSurveyForm({
  onSuccess,
}: {
  onSuccess: () => void;
}) {
  const t = useTranslations('survey');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);
  const [pending, setPending] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError(undefined);

    const submission = addSurveySchema.safeParse({ name });
    if (!submission.success) {
      setError(t('name'));
      return;
    }

    setPending(true);
    try {
      const result = await addSurvey(submission.data.name);
      if (result.ok) {
        onSuccess();
      } else {
        setError(result.error);
      }
    } finally {
      setPending(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label htmlFor="add-survey-name">{t('name')}</Label>
        <Input
          id="add-survey-name"
          type="text"
          placeholder={t('name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      {error && <div className="text-destructive text-sm">{error}</div>}
      <SubmitButton label={t('add_survey')} pending={pending} />
    </form>
  );
}
